import Icon from '@cobliteam/ui/icons';
import { useId } from 'react';

interface AiGradientSpinnerProps {
  size?: 'sm' | 'lg';
}

const GRADIENT = 'linear-gradient(135deg, #001BB8 0%, #9847EE 100%)';

const SIZES = {
  sm: {
    wrapper: 'relative flex h-10 w-10 shrink-0 items-center justify-center',
    viewBox: '0 0 40 40',
    cx: 20,
    cy: 20,
    r: 16,
    strokeWidth: 2,
    arcPath: 'M20 4 A16 16 0 0 1 36 20',
    gradX2: 36,
    gradY2: 20,
    innerBox: 'flex h-6 w-6 items-center justify-center rounded-md',
    iconSize: 'xs' as const,
  },
  lg: {
    wrapper: 'relative flex h-14 w-14 shrink-0 items-center justify-center',
    viewBox: '0 0 56 56',
    cx: 28,
    cy: 28,
    r: 22,
    strokeWidth: 2.5,
    arcPath: 'M28 6 A22 22 0 0 1 50 28',
    gradX2: 50,
    gradY2: 28,
    innerBox: 'flex h-8 w-8 items-center justify-center rounded-lg',
    iconSize: 'sm' as const,
  },
};

const AiGradientSpinner = ({ size = 'lg' }: AiGradientSpinnerProps) => {
  const uid = useId();
  const gradId = `aiSpinnerGrad-${uid.replace(/:/g, '')}`;
  const s = SIZES[size];

  return (
    <div className={s.wrapper}>
      {/* Pulsing ring */}
      <div className='absolute inset-0 rounded-full' style={{ background: GRADIENT, opacity: 0.15, animation: 'pulseRing 2s ease-in-out infinite' }} />

      {/* Spinning arc */}
      <svg className='absolute inset-0 animate-spin' viewBox={s.viewBox} fill='none'>
        <circle cx={s.cx} cy={s.cy} r={s.r} stroke='#e5e7eb' strokeWidth={s.strokeWidth} />
        <path d={s.arcPath} stroke={`url(#${gradId})`} strokeWidth={s.strokeWidth} strokeLinecap='round' />
        <defs>
          <linearGradient id={gradId} x1={s.cx} y1={s.r > 20 ? 6 : 4} x2={s.gradX2} y2={s.gradY2} gradientUnits='userSpaceOnUse'>
            <stop stopColor='#001BB8' />
            <stop offset='1' stopColor='#9847EE' />
          </linearGradient>
        </defs>
      </svg>

      {/* Inner icon */}
      <div className={s.innerBox} style={{ background: GRADIENT }}>
        <Icon name='sparkles' size={s.iconSize} className='text-white' />
      </div>
    </div>
  );
};

export default AiGradientSpinner;
